import {Injectable} from '@angular/core';
import {TasksService} from "./tasks.service";
import { getFunctions, httpsCallable } from 'firebase/functions';


export interface TriggerModel {
    heading: string;
    description: string;
    triggerType: string;
    centreCode: string
    emailTo: any[]
    collaborators: any[]
    triggerId: string
}

@Injectable({
    providedIn: 'root'
})
export class TriggerService {
constructor(private mTaskService:TasksService) {


}

  async checkCounsellingReports() {
    try {
      const functions = getFunctions();
      const checkReports = httpsCallable(functions, 'checkCounsellingImpactReports');

      const result = await checkReports();
      console.log('Reports check result:', result.data);

      // Check individual centre results
      const { results } = result.data as any;
      if (results) {
        results.forEach((r: any) => {
          console.log(`Centre ${r.centreCode}: ${r.message}`);
        });
      }

      return result.data;
    } catch (error) {
      console.error('Error checking counselling reports:', error);
      throw error;
    }
  }
}
